const DOC_TYPES = [
  'identity', 'selfie', 'visa', 'card_vitality',
  'proof_of_address', 'accommodation_of_address', 'hostIdentity',
];

const DOC_LABELS = {
  identity: "Pièce d'identité",
  selfie: 'Selfie',
  visa: 'Visa',
  card_vitality: 'Carte vitale',
  proof_of_address: 'Justificatif de domicile',
  accommodation_of_address: "Attestation d'hébergement",
  hostIdentity: "Pièce d'identité de l'hôte",
};

const MODAL_MAP = {
  selfie: 'ad_file_accept_simple',
  proof_of_address: 'ad_file_accept_simple',
  accommodation_of_address: 'ad_file_accept_simple',
  hostIdentity: 'ad_file_accept_simple',
  identity: 'ad_file_accept_identity',
  visa: 'ad_file_accept_visa',
  card_vitality: 'ad_file_accept_card_vitality',
};

const DOC_CONFIG = [
  { key: 'identity', subType: 'CNI', title: "Carte d'identité", match: (tw) => tw?.identity?.type === 'CNI' },
  { key: 'identity', subType: 'Passport', title: 'Passeport', match: (tw) => tw?.identity?.type !== 'CNI' },
  { key: 'selfie', title: 'Selfie' },
  { key: 'visa', title: 'Visa' },
  { key: 'card_vitality', title: 'Carte vitale' },
  { key: 'proof_of_address', title: 'Justificatif de domicile' },
  { key: 'accommodation_of_address', title: "Attestation d'hébergement" },
  { key: 'hostIdentity', subType: 'CNI', title: "Carte d'identité de l'hôte", match: (tw) => tw?.hostIdentity?.type === 'CNI' },
  { key: 'hostIdentity', subType: 'Passport', title: "Passeport de l'hôte", match: (tw) => tw?.hostIdentity?.type !== 'CNI' },
];

const isExplicitlyNotUploaded = (validated) =>
  validated === 0 || validated === '0';

const hasValidationStatus = (validated) => {
  if (validated === undefined || validated === null || validated === '') return false;
  if (isExplicitlyNotUploaded(validated)) return false;
  const v = Number(validated);
  return !Number.isNaN(v) && v >= 1;
};

const hasUploadedDocumentHint = (doc) =>
  !!(doc?.file || doc?.fileR || doc?.fileV || doc?.name || doc?.updated);

/**
 * Visibility rules aligned with previewTempWorker (slide-over).
 */
const isIdentityDocumentVisible = (tempWorker, { key, match }) => {
  const doc = tempWorker?.[key];
  if (!doc || typeof doc !== 'object') return false;

  let visible = false;

  if (key === 'accommodation_of_address') {
    visible = !isExplicitlyNotUploaded(doc.validated) && (
      hasValidationStatus(doc.validated) || hasUploadedDocumentHint(doc)
    );
  } else if (key === 'hostIdentity') {
    visible = !!doc.validated
      && !isExplicitlyNotUploaded(doc.validated)
      && hasValidationStatus(doc.validated);
  } else {
    visible = hasValidationStatus(doc.validated);
  }

  if (!visible) return false;
  return !match || match(tempWorker);
};

const getIdentityDocumentStatus = (validated, validatedBy) => {
  const v = parseInt(validated, 10);
  if (v === 1) return 4;
  if (v === 2) return validatedBy === 'ai' ? 26 : 5;
  return v;
};

const getVisibleIdentityDocuments = (tempWorker) => {
  if (!tempWorker) return [];

  return DOC_CONFIG
    .filter((config) => isIdentityDocumentVisible(tempWorker, config))
    .map(({ key, subType, title }) => ({
      key,
      subType,
      title,
      dateAdd: tempWorker[key]?.updated,
      status: getIdentityDocumentStatus(
        tempWorker[key]?.validated,
        tempWorker[key]?.validatedBy
      ),
      type: key,
    }));
};

const countIdentityDocumentProgress = (tempWorker) => {
  const visible = getVisibleIdentityDocuments(tempWorker);
  const accepted = visible.filter((doc) => {
    const v = Number(tempWorker?.[doc.key]?.validated);
    return v === 2 || v === 3;
  }).length;

  return { accepted, total: visible.length };
};

module.exports = {
  DOC_TYPES,
  DOC_LABELS,
  MODAL_MAP,
  DOC_CONFIG,
  getVisibleIdentityDocuments,
  countIdentityDocumentProgress,
  getIdentityDocumentStatus,
};
